import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Instagram, ArrowUpRight, Navigation, Clock } from 'lucide-react';
export function FooterSection() {
  return <footer id="contacts" className="w-full bg-zinc-950 text-white pt-24 px-6 md:px-12 lg:px-20 border-t border-white/5" data-id="element-68">
      <div className="max-w-7xl mx-auto" data-id="element-69">
        {/* Header */}
        <div className="mb-16" data-id="element-70">
          <div className="flex items-center gap-3 mb-4" data-id="element-71">
            <div className="w-2 h-2 bg-[#6B7A4A] rounded-full pulse-dot" data-id="element-72" />
            <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest uppercase" data-id="element-73">
              Контакти / Координати
            </span>
          </div>
          <h2 className="font-['Oswald'] text-5xl md:text-6xl font-bold uppercase tracking-widest" data-id="element-74">
            Знайдіть нас
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-stretch" data-id="element-75">
          {/* Left Column - Contact info blocks */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="lg:col-span-5 space-y-6" data-id="element-76">
            {/* Address */}
            <div className="relative bg-neutral-900/50 border border-white/10 p-6" data-id="element-77">
              <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-78" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-79" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-80" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-81" />

              <div className="flex items-start gap-4" data-id="element-82">
                <div className="p-2.5 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-83">
                  <MapPin className="w-5 h-5 text-[#6B7A4A]" data-id="element-84" />
                </div>
                <div data-id="element-85">
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-2 uppercase" data-id="element-86">
                    LOC-01 · Адреса
                  </div>
                  <p className="font-['Oswald'] text-lg uppercase tracking-wide text-white leading-snug" data-id="element-87">
                    Хмельницький
                    <br data-id="element-88" />
                    вул. Героя України
                    <br data-id="element-89" />
                    Володимира Дудченка, 30
                  </p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <a href="tel:+380774500450" className="group relative block bg-neutral-900/50 border border-white/10 hover:border-[#6B7A4A] transition-colors duration-200 p-6" data-id="element-90">
              <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-91" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-92" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-93" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-94" />

              <div className="flex items-start gap-4" data-id="element-95">
                <div className="p-2.5 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-96">
                  <Phone className="w-5 h-5 text-[#6B7A4A]" data-id="element-97" />
                </div>
                <div className="flex-1" data-id="element-98">
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-2 uppercase" data-id="element-99">
                    COMMS-01 · Прямий зв'язок
                  </div>
                  <div className="font-['Oswald'] text-2xl font-bold uppercase tracking-wide text-white" data-id="element-100">
                    +380 77 450 0450
                  </div>
                </div>
                <ArrowUpRight className="w-5 h-5 text-[#6B7A4A] transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-101" />
              </div>
            </a>

            {/* Working hours */}
            <div className="relative bg-neutral-900/50 border border-white/10 p-6" data-id="element-102">
              <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-103" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-104" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-105" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-106" />

              <div className="flex items-start gap-4" data-id="element-107">
                <div className="p-2.5 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-108">
                  <Clock className="w-5 h-5 text-[#6B7A4A]" data-id="element-109" />
                </div>
                <div className="flex-1" data-id="element-110">
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-2 uppercase" data-id="element-111">
                    TIME-01 · Графік роботи
                  </div>
                  <div className="flex items-baseline justify-between gap-4" data-id="element-112">
                    <span className="font-['Oswald'] text-lg uppercase tracking-wide text-white" data-id="element-113">
                      Пн — Пт
                    </span>
                    <span className="font-['Oswald'] text-2xl font-bold tracking-wide text-[#A3E635]" data-id="element-114">
                      9:00 — 18:00
                    </span>
                  </div>
                  <div className="flex items-center gap-2 mt-3 pt-3 border-t border-white/10" data-id="element-115">
                    <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase" data-id="element-116">
                      Сб — Нд
                    </span>
                    <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-600 tracking-widest uppercase" data-id="element-117">
                      Вихідний
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Instagram CTA */}
            <a href="https://instagram.com/win_code_garage" target="_blank" rel="noopener noreferrer" className="group relative block bg-[#6B7A4A] hover:bg-[#7d8c5a] transition-colors duration-200 p-6" data-id="element-118">
              <div className="flex items-center gap-4" data-id="element-119">
                <div className="p-2.5 bg-zinc-950/30 border border-white/20 shrink-0" data-id="element-120">
                  <Instagram className="w-5 h-5 text-white" data-id="element-121" />
                </div>
                <div className="flex-1" data-id="element-122">
                  <div className="font-['JetBrains_Mono'] text-[10px] text-white/70 tracking-widest mb-1 uppercase" data-id="element-123">
                    Слідкуйте в Instagram
                  </div>
                  <div className="font-['Oswald'] text-xl font-bold uppercase tracking-widest text-white" data-id="element-124">
                    @win_code_garage
                  </div>
                </div>
                <ArrowUpRight className="w-6 h-6 text-white transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-125" />
              </div>
            </a>
          </motion.div>

          {/* Right Column - Map Placeholder */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15,
          ease: 'easeOut'
        }} className="lg:col-span-7" data-id="element-126">
            <div className="relative h-full min-h-[400px] bg-neutral-900/50 border border-white/10 overflow-hidden" data-id="element-127">
              {/* Tactical corner brackets */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-[#6B7A4A] z-20 pointer-events-none" data-id="element-128" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-[#6B7A4A] z-20 pointer-events-none" data-id="element-129" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-[#6B7A4A] z-20 pointer-events-none" data-id="element-130" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-[#6B7A4A] z-20 pointer-events-none" data-id="element-131" />

              {/* Live Google Map */}
              <iframe title="Win Code Garage на мапі" src="https://www.google.com/maps?q=Хмельницький,+вулиця+Героя+України+Володимира+Дудченка,+30&hl=uk&z=16&output=embed" className="absolute inset-0 w-full h-full border-0" style={{
              filter: 'grayscale(0.4) contrast(1.05) brightness(0.85)'
            }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-132" />

              {/* Label overlay */}
              <div className="absolute top-4 left-4 z-20 px-3 py-1.5 bg-zinc-950/80 border border-white/10 font-['JetBrains_Mono'] text-[10px] text-zinc-300 tracking-widest uppercase pointer-events-none" data-id="element-133">
                Карта / Win Code Garage
              </div>

              {/* Directions CTA */}
              <a href="https://maps.google.com/?q=Хмельницький+вулиця+Героя+України+Володимира+Дудченка+30" target="_blank" rel="noopener noreferrer" className="absolute bottom-4 right-4 z-20 group flex items-center gap-2 bg-zinc-950 border border-white/10 hover:border-[#6B7A4A] transition-colors duration-200 px-4 py-2.5" data-id="element-134">
                <Navigation className="w-3.5 h-3.5 text-[#6B7A4A]" data-id="element-135" />
                <span className="font-['JetBrains_Mono'] text-xs text-white tracking-widest uppercase" data-id="element-136">
                  Прокласти маршрут
                </span>
              </a>
            </div>
          </motion.div>
        </div>

        {/* Footer bottom strip */}
        <div className="mt-20 pt-8 pb-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-137">
          <div className="flex items-center gap-4" data-id="element-138">
            <span className="font-['Oswald'] text-lg font-bold uppercase tracking-widest text-white" data-id="element-139">
              Win Code Garage
            </span>
            <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-600 tracking-widest uppercase" data-id="element-140">
              UNIT-001 / KHM-UA
            </span>
          </div>
          <div className="font-['JetBrains_Mono'] text-xs text-zinc-600 tracking-widest uppercase" data-id="element-141">
            © {new Date().getFullYear()} Win Code Garage · Усі права захищено
          </div>
        </div>
      </div>
    </footer>;
}